<template>
    <div class="mainWork">
        <NavTab style="margin-top: -20px;" />

        <div class="formBox">
            <el-form ref="myForm" :model="query" size="mini">
                <span class="formBoxItem">
                    <el-form-item label-width="80px" label="预约编号" prop="recordNo">
                        <el-input v-model="query.recordNo" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label-width="80px" label="预约电话" prop="reporterPhone">
                        <el-input v-model="query.reporterPhone" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label-width="100px" label="预约人姓名" prop="reporterName">
                        <el-input v-model="query.reporterName" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label-width="80px" label="是否加急" prop="expedited">
                        <el-select v-model="query.expedited" placeholder="请选择" clearable>
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label-width="120px" label="是否取消预约" prop="status">
                        <el-select v-model="query.cancel" placeholder="请选择" clearable>
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label-width="80px" label="预约时间" prop="districtId">
                        <!-- <el-date-picker v-model="query.appointmentTime" placeholder="选择日期" type="date" value-format="yyyy-MM-dd" ></el-date-picker> -->
                        <el-date-picker
                            start-placeholder="开始日期"
                            range-separator="至"
                            end-placeholder="结束日期"
                            type="daterange"
                            value-format="timestamp"
                            v-model="timeValue"
                        ></el-date-picker>
                        <el-select style="width: auto;" v-model="timeArr" placeholder="请选择时间段" @change="onSelect">
                            <el-option v-for="item in optionsTime" :key="item.dateDesc" :label="item.dateDesc" :value="item.dateDesc"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label-width="100px" label="案件类型" prop="recordType">
                        <el-select v-model="query.recordType" placeholder="请选择" clearable>
                            <el-option v-for="item in caseTypeLists" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label-width="50px">
                        <el-button type="primary" @click="getAccidentList">查询</el-button>
                        <el-button type="primary" v-if="command == '超级管理员' || command == '高级管理员'" @click="exportEx">导出</el-button>
                        <el-button type="primary" v-if="createState" @click="showCreate">创建预约</el-button>
                    </el-form-item>
                </span>
            </el-form>
        </div>
        
        <div class="table">
            <el-table :data="accidentList" max-height="460" border tooltip-effect="dark" style="width: 100%" :header-cell-style="tableHeaderColor" ref="multipleTable" :cell-style="cellStyle">
                <el-table-column label="预约编号" show-overflow-tooltip min-width="160">
                    <template slot-scope="scope">
                        {{scope.row.recordNo}}
                    </template>
                </el-table-column>
                <el-table-column label="预约位置" show-overflow-tooltip min-width="140">
                    <template slot-scope="scope">
                        {{scope.row.location}}
                    </template>
                </el-table-column>
                <el-table-column label="姓名" show-overflow-tooltip min-width="70">
                    <template slot-scope="scope">
                        {{scope.row.reporterName}}
                    </template>
                </el-table-column>
                <el-table-column label="预约人手机号" show-overflow-tooltip min-width="100">
                    <template slot-scope="scope">
                        {{scope.row.reporterPhone}}
                    </template>
                </el-table-column>
                <el-table-column label="预约时间段" show-overflow-tooltip min-width="170">
                    <template slot-scope="scope">
                        {{scope.row.appointmentTime}}
                    </template>
                </el-table-column>
                <el-table-column label="车牌号" show-overflow-tooltip min-width="80">
                    <template slot-scope="scope">
                        {{scope.row.carPlate}}
                    </template>
                </el-table-column>
                <el-table-column label="驾驶证号" show-overflow-tooltip min-width="150">
                    <template slot-scope="scope">
                        {{scope.row.driverLicence}}
                    </template>
                </el-table-column>
                <el-table-column label="驾驶证注册时间" show-overflow-tooltip min-width="110">
                    <template slot-scope="scope">
                        {{scope.row.driverCardTime}}
                    </template>
                </el-table-column>
                <el-table-column label="行驶证注册时间" show-overflow-tooltip min-width="110">
                    <template slot-scope="scope">
                        {{scope.row.vehicleCardTime}}
                    </template>
                </el-table-column>
                <el-table-column label="预约大队" show-overflow-tooltip min-width="250">
                    <template slot-scope="scope">
                        {{scope.row.organizationName}}
                    </template>
                </el-table-column>
                <el-table-column label="状态" show-overflow-tooltip min-width="100">
                    <template slot-scope="scope">
                        {{scope.row.status | orderListFilter}}
                    </template>
                </el-table-column>
                <el-table-column label="案件类型" show-overflow-tooltip min-width="70">
                    <template slot-scope="scope">
                        {{scope.row.type == 2 ? "一般程序" : "简易程序"}}
                    </template>
                </el-table-column>
                <el-table-column label="是否加急" show-overflow-tooltip min-width="70">
                    <template slot-scope="scope">
                        {{scope.row.expedited == 1 ? "是" : "否"}}
                    </template>
                </el-table-column>
                <el-table-column label="取消原因" show-overflow-tooltip min-width="80">
                    <template slot-scope="scope">
                        {{scope.row.cancelReason}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="160">
                    <template slot-scope="scope">
                        <template v-if="scope.row.status < 3 || scope.row.status == 7">
                            <span class="reMessage" @click="toDetail(scope.row)">详情</span>
                            <span @click="getRoomId(scope.row.id, scope.row)">进入处理</span>
                        </template>
                        <template v-else>
                            <span @click="getRoomId(scope.row.id, scope.row)">预约详情</span>
                        </template>
                        <template v-if="scope.row.payqrStatus == 1">
                            <span class="qr_p" @click="showQR(scope.row)">支付码</span>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="accidentList.length">
                <nt-pagination ref="child" @fetchData="getMyAccidentList"></nt-pagination>
            </div>
        </div>

        <transition>
            <videoPlat ref="videoPlat" v-if="videoState" :roomId="roomId" @reStartMask="reStartMask" @startMethod="startMethod" @closeMask="closeMask"></videoPlat>
        </transition>
        <transition>
            <videoEasy ref="videoEasy" v-if="videoEasyState" :roomId="roomId" @reStartMask="reStartMask" @startMethod="startMethod" @closeMask="closeMask"></videoEasy>
        </transition>

        <el-dialog width="80%" top="20px" title="详情" center :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true">
            <Detail :roomId="roomId" :key="component_key" :rowItem="rowItem" @onClose="onClose" />
        </el-dialog>

        <el-dialog width="30%" title="罚款支付码" center :visible.sync="imageVisible" :close-on-click-modal="false" :close-on-press-escape="false" :modal-append-to-body="false" :before-close="hideQR" destroy-on-close>
            <QrImage v-if="imageVisible" :key="component_key" :roomId="roomId" :QRimageUrl="QRimageUrl" @hideQR="hideQR" />
        </el-dialog>

        <el-dialog width="50%" top="0" title="创建预约单" center :visible.sync="createVisible" :close-on-click-modal="false" :close-on-press-escape="false" :modal-append-to-body="false" :show-close="false" :before-close="hideCreate" destroy-on-close>
            <Create v-if="createVisible" :key="component_key" @hideCreate="hideCreate" />
        </el-dialog>

    </div>
</template>

<script>
import config from "@/common/env"
import { mapState } from "vuex"
import NavTab from "@/components/navTab.vue" 
import videoPlat from "./video.vue"
import videoEasy from "./videoEasy.vue"
import Detail from "./components/detail.vue"
import QrImage from "./components/image.vue"
import Create from "./components/create.vue"

export default {
    name: 'workPlat',
    components: {
        NavTab,
        videoPlat,
        videoEasy,
        Detail,
        QrImage,
        Create,
    },
    data() {
        return {
            hasAlreadyEnter: {},
            videoState: false,
            videoEasyState: false,
            roomId: null,
            accidentList: [],

            query: {
                recordNo: null,
                reporterPhone: null,
                reporterName: null,
                expedited: null,
                // appointmentTime: null,
                appointmentStartTime: null,
                appointmentEndTime: null,
                startTime: null,
                endTime: null,
                cancel: null,
                recordType: null,
                page: 1,
                size: 10
            },
            nowData: [],
            timeArr: null,
            optionsTime: [
                {dateDesc: "全部", start: null, end: null}
            ],
            options: [
                {value: null, label: "全部"},
                {value: true, label: "是"},
                {value: false, label: "否"}
            ],
            caseTypeLists: [
                {value: null, label: "全部"},
                {value: 1, label: "简易程序"},
                {value: 2, label: "一般程序"},
            ],
            dialogVisible: false,
            rowItem: null,
            component_key: null,
            timeValue: [new Date().getTime(), new Date().getTime()],
            imageVisible: false,
            QRimageUrl: null,
            createState: false,
            createVisible: false,

        }
    },
    computed: {
        ...mapState(['onlineStatus', 'command', 'myAccidentList']),

    },
    created() {
        let userinfos = JSON.parse(localStorage.getItem('userinfos'));
        this.createState = userinfos && userinfos.pcCreateStatus ? true : false;
        // this.query.appointmentTime = this.AppUtils.timestampToTime(new Date()).split(" ")[0];
        this.getSelList();
        
    },
    mounted() {
        // this.getAccidentList();
        
    },
    beforeDestroy() {
        
    },
    methods: {
        showCreate() {
            this.createVisible = true;
            this.component_key = Date.now();
        },
        hideCreate(obj) {
            this.createVisible = false;
            if(obj && obj.state) this.getAccidentList();
        },

        getNowTime() {
            let date = new Date();
            let h = date.getHours() + ':';
            let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            return h + m;
        },

        getSelList() {
            let nowTime = Number(this.getNowTime().replace(":", ""));
            
            this.$axios.get(`/admin/appointment/daterules/selList`).then(res => {
                let datas = this.AppUtils.checkResponse(res);
                let { code, data } = datas;
                if(code == 0) {
                    let nowData = data.filter(item => Number((item.start).replace(":", "")) <= Number(nowTime) && Number((item.end).replace(":", "")) > Number(nowTime));
                    this.nowData = nowData;
                    this.timeArr = nowData.length > 0 ? nowData[0].dateDesc : null;
                    this.optionsTime = this.optionsTime.concat(data);
                    this.getAccidentList();
                } else {
                    this.getAccidentList();
                }
            }).catch(() => {
                this.getAccidentList();
            })
        },

        toDetail(row) {
            this.roomId = row.id;
            this.rowItem = row;
            this.dialogVisible = true;
            this.component_key = new Date().getTime();
        },

        onClose(val) {
            this.dialogVisible = val.state;
            if(val.send) {
                this.getAccidentList();
            }
            if(val.next) {
                this.getRoomId(this.roomId, this.rowItem);
            }
        },

        showQR(row) {
            this.imageVisible = true;
            this.component_key = Date.now();
            this.roomId = row.id;
            this.QRimageUrl = row.payQrfile || null;
        },
        hideQR() {
            this.imageVisible = false;
            this.roomId = null;
            this.QRimageUrl = null;
            this.getAccidentList();
        },

        onSelect(e) {
            let data = this.optionsTime.filter(item => item.dateDesc == e);
            this.nowData = [];
            this.query.startTime = data[0].start;
            this.query.endTime = data[0].end;
        },

        getAccidentList() {
            this.query.page = 1;
            this.query.size = 10;
            this.getMyAccidentList();
        },

        getMyAccidentList(args) {
            if(this.timeValue) {
                this.query.appointmentStartTime = this.AppUtils.timestampToTime(this.timeValue[0]).split(" ")[0];
                this.query.appointmentEndTime = this.AppUtils.timestampToTime(this.timeValue[1]).split(" ")[0];
            } else {
                this.query.appointmentStartTime = null;
                this.query.appointmentEndTime = null;
            }

            if(this.nowData.length > 0) {
                this.query.startTime = this.nowData[0].start;
                this.query.endTime = this.nowData[0].end;
            }

            if (args) {
                if (args.page) { //分页
                    this.query.page = args.page; //当前页数
                    this.query.size = args.pageSize; //每页显示多少条
                }
            }
            
            let _this = this;
            this.$axios.post('/admin/appointment/list', this.query).then(res => {
                let data = this.AppUtils.checkResponse(res);
                if (data.code == 0) {
                    this.accidentList = data.data.list;
                    if(this.accidentList.length > 0) {
                        this.$nextTick(() => {
                            _this.$refs.child.initPage(data.data.total, _this.query.page, _this.query.size)
                        })
                    }
                }
            })
        },

        getRoomId(id, row) {
            // let myAccidentList = this.$store.state.myAccidentList || [];
            let myAccidentList = [];
            let filterRes = this.accidentList.filter(accident => accident.id == id);
            let filterResMy = myAccidentList.filter(accident => accident.id == id);
            if (filterRes.length) {
                if (!filterResMy.length) {
                    myAccidentList.push(filterRes[0]);
                    this.$store.commit('MyAccidentList', myAccidentList);
                }
            }

            this.roomId = id;
            // this.rowItem = row;
            let key = 'enter' + id;
            if(!this.hasAlreadyEnter[key]) {
                sessionStorage.setItem('isShowView', '')
                this.hasAlreadyEnter[key] = 1;
            } else {
                
            }
            this.canEdit(id, row);
        },

        canEdit(id, row) {
            this.$axios.get(`/admin/appointment/handle/${id}`).then(res => {
                if (res.data.code == 0) {
                    if(row.type && row.type == 2) {
                        this.videoState = true; //一般
                    } else {
                        this.videoEasyState = true; //简单
                    }
                } else if (res.data.code == 107003) {
                    this.$confirm(res.data.msg, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        
                    }).catch(() => {

                    })
                } else {
                    this.$message.error(res.data.msg);
                }
            })
        },

        //导出
        exportEx() {
            if (!this.accidentList.length) {
                return this.AppUtils.alert("暂无可导出数据");
            }
            this.$axios.post("/admin/appointment/export", this.query, {
                    responseType: "arraybuffer",
            }).then((res) => {
                let fileName = "预约记录.xls";
                let blob = new Blob([res.data], {
                    type: "application/x-xls"
                });
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, fileName);
                } else {
                    let link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                    window.URL.revokeObjectURL(link.href);
                }
            })
        },

        reStartMask() {
            this.getAccidentList();
        },
        
        startMethod() {
            this.getAccidentList();
        },
        
        closeMask() {
            this.videoState = false;
            this.videoEasyState = false;
        },
        
        cellStyle({  row,  column, rowIndex, columnIndex }) {
            return 'height:10px';
        },

        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #f4f5f7;color: #333;text-indent:5px'
            }
        },

    }
}
</script>

<style lang="scss" scoped>
.mainWork {
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    padding: 20px;
    overflow: hidden;

    .table {
        width: 100%;
        padding: 20px 0 0 0;
        background: #fff;

        span {
            font-size: 13px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #1e4682;
            cursor: pointer;
        }

        .reMessage {
            padding-right: 5px;
            box-sizing: border-box;
            border-right: 1px solid #ccc;
        }
        .qr_p {
            padding-left: 5px;
            box-sizing: border-box;
            border-left: 1px solid #ccc;
            color:#409EFF;
        }
    }
}

.priority {
    background-color: rgb(157, 197, 240);
    color: rgb(6, 135, 241) !important;
}

.table /deep/ .cell {
    padding-left: 0;
}
.table /deep/ .el-tooltip {
    width: auto!important;
}
.table /deep/ .el-table .cell {
    padding: 0;
}

.formBox {
	width: 100%;
    padding: 15px 0 0;
    margin: 20px auto;
    background: #fff;
}
.formBoxItem {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}

</style>



// WEBPACK FOOTER //
// workPlat.vue?565707bc